import React from 'react';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import styles from './dayviewtimelinegrid.module.scss';
import MoreEvent from '../ScheduleModal/MoreEvent';
import EventCell from '../ScheduleModal/EventCell';
import { rangeInteract } from '../TimeLinePicker/util';
import { isAlldayOrCrossEvent } from '../ScheduleModal/util';
const ALL_DAY_EVENTS_NUM = 4;
const GridHeader = ({ events, busy = false, text = '', indicatorRange }) => {
    const isBusyEvent = event => {
        if (!indicatorRange) {
            return false;
        }
        return !!event.allDay || rangeInteract([moment(event.start), moment(event.end)], indicatorRange) !== null;
    };
    const allEvents = events.filter(c => isAlldayOrCrossEvent(c));
    const allDayAndCrossEvents = cloneDeep(allEvents).map(i => {
        i.textColor = isBusyEvent(i) ? '#51555c' : '#a8aaad';
        i.color = isBusyEvent(i) ? 'rgba(247, 79, 79, 0.2)' : 'rgba(232, 232, 232, 0.6)';
        return i;
    });
    const renderAllDay = (events) => {
        if (!events || !events.length) {
            return null;
        }
        if (events.length <= ALL_DAY_EVENTS_NUM) {
            return events.map(i => (React.createElement("div", { className: styles.eventOuter, key: i.scheduleId },
                React.createElement(EventCell, { event: i, judgePast: false }))));
        }
        return renderMoreAllDayEvent(events);
    };
    const renderMoreAllDayEvent = (events) => (React.createElement(React.Fragment, null,
        events.map((i, idx) => idx < ALL_DAY_EVENTS_NUM - 1 ? (React.createElement("div", { className: styles.eventOuter, key: i.scheduleId },
            React.createElement(EventCell, { event: i, judgePast: false }))) : null),
        React.createElement(MoreEvent, { num: ALL_DAY_EVENTS_NUM, events: events, judgePast: false })));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.gridHeader },
            React.createElement("div", { className: styles.gridHeaderTitle },
                React.createElement("span", { className: styles.headerContent },
                    React.createElement("span", { title: text }, text)),
                busy && React.createElement("i", { className: styles.busyIcon })),
            renderAllDay(allDayAndCrossEvents))));
};
export default GridHeader;
